import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import Purchase from "../purchase/purchase";
import Stocks from "../stocks/stocks";
import { useSelector } from "react-redux";
import FranchiseRequirement from "./ProductDetails";
import CompanyInformation from "./companyInformation";
import ProductDetails from "./ProductDetails";
import AddProduct from "./AddProduct";
import Enquiries from "./enquiries";

export const WhiteLables = ({}) => {
  const [ModalData, SetModalData] = React.useState("all");
  const [open, setOpen] = React.useState(null);
  const [enquiries, setEnquiries] = React.useState(null);

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {(!businessChooseTab ||
            businessChooseTab?.value == "companyinformation") && (
            <CompanyInformation />
          )}
          {/* {(!businessChooseTab ||
            businessChooseTab?.value == "") && <ProductDetails />} */}

          {/* {businessChooseTab?.value == "productdetails" && (
            <>
              {!open && (
                <ProductDetails
                  setOpen={setOpen}
                  setEnquiries={(da) => {
                    setEnquiries(da);
                  }}
                />
              )}
              {open && (
                <AddProduct
                  setOpen={setOpen}
                  //   enquiries={enquiries}
                  backEnquire={() => {
                    // setEnquiries(null);
                  }}
                />
              )}
              {enquiries && (
                <Enquiries
                  setOpen={setOpen}
                  enquiries={enquiries}
                  backEnquire={() => {
                    setEnquiries(null);
                  }}
                />
              )}
            </>
          )} */}
          {businessChooseTab?.value === "productdetails" && (
            <>
              {enquiries ? (
                <Enquiries
                  setOpen={setOpen}
                  enquiries={enquiries}
                  backEnquire={() => {
                    setEnquiries(null);
                    setOpen(false);
                  }}
                />
              ) : open ? (
                <AddProduct
                  open={open}
                  ModalData={ModalData}
                  setOpen={setOpen}
                  backEnquire={() => {}}
                />
              ) : (
                <ProductDetails
                  setOpen={setOpen}
                  setEnquiries={setEnquiries}
                  SetModalData={(data) => {
                    SetModalData(data);
                  }}
                />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
